export default __webpack_public_path__ + "static/media/22.f7effeb2.png";